// RITA-1547 — Bearbeiten-Seite des Entwurfs „Vertrag erstellen“ (Bildentwurf 3b, Bild C, freigegeben von
// Julia am 20.10.2026). Von oben nach unten: Pfadzeile; Titelzeile mit Titel und Speicherstand links,
// „Zurück zum Berater“, „Entwurf speichern“ und „Drucken“ rechts; darunter links die Reiter Anschreiben/Vertrag;
// darunter Werkzeugleiste und Seiten wie im Vorlagen-Editor, ohne Platzhalterleiste (F3). Beide Dokumente
// haben je einen eigenen Editorzustand: Ein Reiterwechsel verliert nichts, auch Rückgängig merkt sich jeder
// Reiter für sich. Gerendert wird nur der aktive Reiter, weil die Seitenaufteilung im sichtbaren Dokument misst.
//
// RITA-1549 (Skizze 3c, Bild C, F3/F4/F11/F14) — „Drucken“: Das kleine Drucken-Fenster fragt je enthaltenem
// Dokument ein Häkchen ab; gedruckt wird der sichtbare Editorstand, auch nicht gespeicherte Änderungen (Herkunft
// `draft`). Den Entwurf erledigt der Druck nur, wenn alle enthaltenen Dokumente angehakt sind und die Sitzung eine
// Revision kennt (F11) – sonst bleibt er. Nach einem vollständigen Druck geht es ohne Verlassen-Rückfrage zurück
// zum Berater (F3). Nach einem Teil-Druck bleibt die Seite mit einem Hinweis offen: Das nicht gedruckte Dokument
// bleibt im Entwurf (F11), und ungespeicherte Änderungen daran dürfen nicht verloren gehen – der Verlassensschutz
// bleibt scharf. Fehler bleiben als Hinweis auf der Seite; ein Entwurfskonflikt (CONFLICT/DISCARDED) fragt wie
// beim Speichern (F14): nach DISCARDED mit „Zurück zum Berater“ statt „Gespeicherten Stand laden“.
//
// RITA-1552: Die Editoren sind je Art als Partial typisiert (die Art Anschreiben Rücksendung kommt hinzu); die Seite
// führt genau die Editoren der Arten ihres Vorgangs (siehe unten).
//
// RITA-1552 (Skizze Rücklauf, Bild F b; F9) — Rückfrage „Beim Anlegen fehlten Angaben“: nach dem kleinen
// Drucken-Fenster und der Vorprüfung, vor dem Druck. Die Berater-Daten sind hier schon Text; bekannt ist nur, was beim
// Anlegen des Entwurfs leer war (`advisor_values`, ohne die „abweichenden“ Angaben). RITA-1600 (Fund 107): Die Liste
// nennt nur Angaben der angehakten Dokumente; welche ein Dokument braucht, kommt aus seiner Vorlage
// (`beraterschluessel`). Ist die Vorlage seit dem Entwurf geändert oder gelöscht, nennt sie wie bisher alle leeren
// Angaben des Entwurfs (Julia 03.11.2026). „Abbrechen“ schließt beide Fenster, „Trotzdem
// drucken“ druckt die schon geprüfte Eingabe synchron im Klick (Tab-Zwang des Druck-Hooks); die Rückfrage bleibt
// während des Drucks gesperrt offen wie das Drucken-Fenster. „Trotzdem drucken“ nach einem Konflikt (F14) fragt nicht
// noch einmal.
//
// RITA-1552 (Skizze Rücklauf, Bild E; F8 und Entscheidung E6 von Julia freigegeben) — Dieselbe Seite bearbeitet auch
// den eigenen Entwurf der Rücksendung (`start.vorgang` 'return'): ein Reiter (Anschreiben Rücksendung), Pfad „Berater ›
// <Name> › Rücksendung drucken › Bearbeiten“, Titel „Rücksendung drucken – <Name>“; Speichern über den Entwurf der
// Rücksendung (eigene Revision), Speicherwarnung, Verlassen-Rückfrage, Konflikt- und „hat sich geändert“-Dialoge wie 3b.
// „Drucken“ öffnet das kleine Drucken-Fenster ohne Häkchen (ein Dokument; Text wie 3c); danach gilt alles wie beim
// Vertrag (vollständiger Druck mit der Revision der Sitzung, Rückfrage „Beim Anlegen fehlten Angaben“, Rückkehr zum
// Berater). Der Druck schickt immer den Vertragsbezug (E6, Befund F1 aus dem Review von MR 1): `start.vertragsbezug` ist
// der „Gehört zu“-Vertrag, den die Seite beim Laden der Sitzung bestimmt hat (neuester im PRM gedruckter Vertrag, null =
// keiner). Wurde inzwischen ein neuer Vertrag gedruckt, lehnt der Server ab (CONTRACT_CHANGED, Hinweis „Inzwischen wurde
// ein neuer Vertrag gedruckt – Fenster neu öffnen.“); die Seite bestimmt den Vertrag dann neu, sodass ein erneut
// geöffnetes Drucken-Fenster zum jetzt neuesten Vertrag druckt. Bis dahin ist „Drucken“ gesperrt.
//
// RITA-1601 (Funde 63 und 128; Wortlaut und Lage von Julia am 04.11.2026 freigegeben) — Rückfragen vor dem Druck mit
// Vertrag: Ein Druck mit Vertrag ersetzt den zuletzt gedruckten Vertrag (Server, Entscheidung 4) – auch über
// „Weiterbearbeiten“, auch einen unterschriebenen, auch aus einem älteren Entwurf. Deshalb lädt „Drucken“ in der
// Titelzeile beim Vorgang Vertrag zugleich das Aktionsprotokoll frisch (`onProtokollLaden`, no-cache); das kleine
// Drucken-Fenster wartet mit seinem „Drucken“ darauf (danach muss der Druck synchron im Klick beginnen, Tab-Zwang). Gibt
// es einen Druck mit Vertrag, dessen Ersetzen die Person noch nicht bestätigt hat (`bestaetigterVertragsdruck`: aus der
// Karte über „Trotzdem neuen erstellen“ und die Adresse, oder aus dieser Seite), fragt die Seite nach dem Fenster „Schon
// ein Vertrag gedruckt“ – mit Datum, ob schon ein Scan hochgeladen ist und ob der gespeicherte Entwurf älter ist als der
// Vertrag. Druckt inzwischen jemand anderes, ist es ein anderer Vertrag: Es wird wieder gefragt. Nur das Anschreiben
// fragt nicht (es ersetzt nichts) und wartet auf nichts. Scheitert das Laden des Protokolls, bleibt das Fenster mit
// Hinweis offen und nur der Druck mit Vertrag gesperrt (Abschlussreview W1). Ist beim
// Berater ein abweichender Vertragsinhaber eingetragen und steht sein Name nicht im Text des Vertrags, steht ein gelber
// Kasten oben über dem Text (verschwindet, sobald der Name dort steht – auch von Hand ergänzt), und der Druck mit Vertrag
// fragt „Der Vertragsinhaber fehlt im Vertrag“. Mehrere Gründe (auch „Beim Anlegen fehlten Angaben“) stehen in einer
// Rückfrage „Bitte vor dem Druck prüfen“ (services/druckrueckfragen.ts, components/DruckDialoge.tsx).
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Tab, Tabs, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import SaveIcon from '@mui/icons-material/Save';
import type { ContractCreationKind, ContractCreationPrintInput } from 'global-intern-types';
import { useSnackbar } from '../../../components/snackbar';
import { PagePathname } from '../../../routes/paths';
import useVertragsartenNeuladbar from '../../templates/hooks/useVertragsartenNeuladbar';
import { useVertragEditor, VertragEditorApi } from '../../templates/contractEditor/editor/useVertragEditor';
import VertragArbeitsbereich from '../../templates/contractEditor/components/VertragArbeitsbereich';
import VertragLeistenRahmen, {
  VertragTitelzeile,
  useVertragLeisten,
} from '../../templates/contractEditor/components/VertragLeistenRahmen';
import Verlassensschutz from '../../templates/contractEditor/components/Verlassensschutz';
import { APP_KOPF_ABSTAND_PX } from '../../templates/contractEditor/editor/VertragEditor';
import { inhaltMindestbreitePx } from '../../templates/contractEditor/layout/leistenplatz';
import { A4_BREITE_MM, mmZuPx } from '../../templates/contractEditor/layout/seitengeometrie';
import HandbuchArbeitsflaeche from '../../handbuch/components/HandbuchArbeitsflaeche';
import { leeresDokument } from '../../templates/contractEditor/model/erzeugen';
import type { Platzhalterbelegung } from '../../templates/contractEditor/model/platzhalterwerte';
import { speicherdokument } from '../../templates/contractEditor/model/speicherform';
import type { Vertragsdokument } from '../../templates/contractEditor/model/types';
import type { Druckeintrag } from '../api/vertragsdruck';
import useEntwurfSpeichern, { Herkunft, Speicherstand } from '../hooks/useEntwurfSpeichern';
import useVertragDrucken, { Druckergebnis, Druckkonflikt } from '../hooks/useVertragDrucken';
import {
  alleEnthaltenAngehakt,
  Druckauswahl,
  druckeingabeAusEditoren,
  Druckteil,
  vorpruefung,
} from '../services/druckdokumente';
import { Druckgruende, hatGruende, schonGedrucktGrund, vertragsinhaberFehlt } from '../services/druckrueckfragen';
import { beraterschluesselDerAuswahl, fehlendeAngabenAusGemerkten } from '../services/fehlendeAngaben';
import { letzterVertragsdruck } from '../services/vertragsbloecke';
import { ART_KURZ } from '../services/vertragserstellungTexte';
import {
  ABGELEGT_NICHT_GEOEFFNET,
  DRUCKEN,
  PROTOKOLL_LADEFEHLER,
  TEIL_GEDRUCKT_HINWEIS,
  vorlageGeaendertText,
  WIRD_GEDRUCKT,
} from '../services/vertragsdruckTexte';
import { heutigesDatum } from '../services/vertragPlatzhalterwerte';
import {
  ENTWURF_SPEICHERN,
  gespeichertAmText,
  KEINE_VORLAGE_REITER,
  NICHT_GESPEICHERTE_AENDERUNGEN,
  NOCH_NICHT_GESPEICHERT,
  PFAD_BEARBEITEN,
  PFAD_BERATER,
  vertragsinhaberFehltSeiteText,
  WIRD_GESPEICHERT,
  ZURUECK_ZUM_BERATER,
} from '../services/vertragsentwurfTexte';
import type { Vorgang } from '../services/vorgang';
import { VORGANG_KONFIG } from '../services/vorgangskonfiguration';
import { DruckenDialog, DruckKonfliktDialog, DruckRueckfrageDialog } from './DruckDialoge';
import {
  Aenderungshinweis,
  EntwurfGeaendertDialog,
  EntwurfKonfliktDialog,
  SeiteVerlassenDialog,
} from './EntwurfDialoge';

/**
 * Offene Rückfrage zum Drucken: das Häkchen-Fenster (F4), die Rückfrage vor dem Druck mit der schon geprüften Eingabe und
 * ihren Gründen (RITA-1552 „Beim Anlegen fehlten Angaben“, RITA-1601 „Schon ein Vertrag gedruckt“ und „Der
 * Vertragsinhaber fehlt im Vertrag“) oder die Warnung bei einem Entwurfskonflikt (F14).
 */
type Druckfrage =
  | { art: 'auswahl' }
  | {
      art: 'rueckfrage';
      eingabe: ContractCreationPrintInput;
      vollstaendig: boolean;
      /** Revision der Sitzung bei vollständiger Auswahl (F11), sonst null. */
      erwartet: string | null;
      gruende: Druckgruende;
    }
  | { art: 'konflikt'; konflikt: Druckkonflikt }
  | { art: 'verworfen' };

export interface EntwurfsteilStart {
  kind: ContractCreationKind;
  herkunft: Herkunft;
  dokument: Vertragsdokument;
  /**
   * RITA-1600 (Fund 107): Schlüssel der Berater-Daten, die dieses Dokument braucht (aus seiner Vorlage). Fehlt er oder
   * ist er null (Vorlage seit dem Entwurf geändert oder gelöscht), nennt die Rückfrage wie bisher alle leeren Angaben.
   */
  beraterschluessel?: string[] | null;
}

export interface EntwurfStart {
  /** Enthaltene Dokumente; fehlt eine Art, gab es dafür keine passende Vorlage. */
  teile: EntwurfsteilStart[];
  advisorValues: Record<string, string> | null;
  /**
   * Revision, die beim Speichern ersetzt werden darf (geöffnet oder in der Rückfrage bestätigt); null = keine
   * bestätigt. Gibt es trotzdem einen Entwurf, warnt das Speichern (CONFLICT).
   */
  revision: string | null;
  /** Gesetzt, wenn der Inhalt dem gespeicherten Entwurf entspricht (Weiterbearbeiten). */
  gespeichert: Speicherstand | null;
  /** Hinweis beim Öffnen, wenn sich Vorlage oder Berater-Daten seitdem geändert haben (Bild E). */
  hinweis: Aenderungshinweis | null;
  reiter: ContractCreationKind;
  /** RITA-1552: „Vertrag erstellen“ oder „Rücksendung drucken“ (Skizze Rücklauf, Bild E); gilt für die ganze Sitzung. */
  vorgang: Vorgang;
  /**
   * RITA-1552 (E6), nur Rücksendung: Kennung des Drucks mit Vertrag, zu dem die Rücksendung gehört (beim Laden der
   * Sitzung der neueste im PRM gedruckte Vertrag); null = keiner aus dem PRM (Fall B). Beim Vertrag null.
   */
  vertragsbezug: number | null;
}

export const beraterAdresse = (agentId: number) =>
  `${PagePathname.beraterBearbeiten.replace(':number', String(agentId))}?bereich=vertrag`;

interface Props {
  agentId: number;
  beraterName: string;
  start: EntwurfStart;
  heute: Date;
  /** Konflikt: den gespeicherten Stand laden (eigene Änderungen verwerfen). */
  onStandLaden: () => void;
  /**
   * Hinweis E: neu aus den Vorlagen beginnen; ersetzt werden darf nur die Revision dieser Sitzung. Liefert die
   * Meldung, wenn keine Vorlage passt.
   */
  onNeuBeginnen: (revision: string | null) => Promise<string | null>;
  onGespeichert?: () => void;
  /**
   * Aktionsprotokoll des Beraters frisch laden (nur seine Einträge; wirft bei einem Ladefehler). RITA-1552 (E6), nur
   * Rücksendung: daraus den „Gehört zu“-Vertrag neu bestimmen, nachdem der Server CONTRACT_CHANGED gemeldet hat.
   * RITA-1601 (Fund 128), nur Vertrag: daraus beim Klick auf „Drucken“ den Vertrag, den ein Druck mit Vertrag ersetzen würde.
   */
  onProtokollLaden: () => Promise<Druckeintrag[]>;
  /** RITA-1601 (Fund 63): abweichender Vertragsinhaber des Beraters (gespeicherter Stand); leer = keiner. */
  vertragsinhaber?: string;
  /**
   * RITA-1601 (Fund 128): Kennung des Drucks mit Vertrag, dessen Ersetzen schon bestätigt ist (Karte oder diese Seite);
   * null = keiner. Für ihn fragt die Seite nicht noch einmal „Schon ein Vertrag gedruckt“.
   */
  bestaetigterVertragsdruck?: number | null;
  /** „Trotzdem drucken“ der Rückfrage „Schon ein Vertrag gedruckt“: dieser Vertrag darf ersetzt werden. */
  onVertragsdruckBestaetigt?: (eintragId: number) => void;
}

// RITA-1585: Neben der Handbuch-Spalte bleibt das ganze A4-Blatt samt Seitenrahmen; diese Seite hat keine
// Platzhalterleiste (feste Werte), deshalb kein Leistenbedarf.
const INHALT_MINDESTBREITE_PX = inhaltMindestbreitePx(mmZuPx(A4_BREITE_MM));

function EntwurfInhalt({
  agentId,
  beraterName,
  start,
  heute,
  onStandLaden,
  onNeuBeginnen,
  onGespeichert,
  onProtokollLaden,
  vertragsinhaber = '',
  bestaetigterVertragsdruck = null,
  onVertragsdruckBestaetigt,
}: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const leisten = useVertragLeisten();
  // RITA-1552: Arten, Pfad, Titel, Häkchen und Entwurf je Vorgang (für den Vertrag die bisherigen Werte).
  const konfig = VORGANG_KONFIG[start.vorgang];
  const { arten } = konfig;
  const leer = useMemo(() => leeresDokument(), []);
  const teil = (art: ContractCreationKind) => start.teile.find((eintrag) => eintrag.kind === art);
  // Feste Zahl von Editoren (Regeln der Hooks); die Arten eines anderen Vorgangs bleiben leer und ungenutzt.
  const anschreiben = useVertragEditor(teil('dispatch_letter')?.dokument ?? leer);
  const vertrag = useVertragEditor(teil('contract')?.dokument ?? leer);
  const ruecksendung = useVertragEditor(teil('return_letter')?.dokument ?? leer);
  const alleEditoren: Record<ContractCreationKind, VertragEditorApi> = {
    dispatch_letter: anschreiben,
    contract: vertrag,
    return_letter: ruecksendung,
  };
  const editoren: Partial<Record<ContractCreationKind, VertragEditorApi>> = Object.fromEntries(
    arten.map((art) => [art, alleEditoren[art]]),
  );
  const [herkunft] = useState(() => Object.fromEntries(start.teile.map((eintrag) => [eintrag.kind, eintrag.herkunft])));
  const entwurf = useEntwurfSpeichern({
    agentId,
    vorgang: start.vorgang,
    arten,
    editoren,
    herkunft,
    advisorValues: start.advisorValues,
    startRevision: start.revision,
    startGespeichert: start.gespeichert,
    onGespeichert,
  });
  const [reiter, setReiter] = useState<ContractCreationKind>(() =>
    teil(start.reiter) && arten.includes(start.reiter)
      ? start.reiter
      : (start.teile.find((eintrag) => arten.includes(eintrag.kind))?.kind ?? arten[0]),
  );
  const vertragsarten = useVertragsartenNeuladbar();
  const datum = useMemo<Platzhalterbelegung>(() => ({ werte: { HEUTIGES_DATUM: heutigesDatum(heute) } }), [heute]);
  const freigabeRef = useRef<() => void>(() => undefined);
  const [verlassen, setVerlassen] = useState<(() => void) | null>(null);
  const [hinweis, setHinweis] = useState(start.hinweis);
  const [keineVorlage, setKeineVorlage] = useState<string | null>(null);
  const [neuLaedt, setNeuLaedt] = useState(false);
  const zumBerater = beraterAdresse(agentId);

  // RITA-1549 — Drucken von dieser Seite (Bild C).
  const druck = useVertragDrucken({ agentId });
  const { enqueueSnackbar } = useSnackbar();
  const [druckfrage, setDruckfrage] = useState<Druckfrage | null>(null);
  /** Meldung der Vorprüfung (vor dem Tab) bzw. „Vorlage geändert“; Fehler der Mutation stehen in `druck.fehler`. */
  const [druckHinweis, setDruckHinweis] = useState('');
  /** Erfolgshinweis nach einem Teil-Druck (die Seite bleibt offen). */
  const [druckErfolg, setDruckErfolg] = useState('');
  /**
   * Zuletzt gesendeter Druck: „Trotzdem drucken“ druckt genau diese Eingabe noch einmal; `vollstaendig` (alle
   * enthaltenen Dokumente angehakt, F11) entscheidet nach dem Druck zwischen Rückkehr zum Berater und Bleiben.
   * RITA-1552: mit dem Vertragsbezug, mit dem sie gesendet wurde.
   */
  const letzterDruck = useRef<{
    eingabe: ContractCreationPrintInput;
    vollstaendig: boolean;
    vertragsbezug: number | null;
  } | null>(null);
  // Antworten nach dem Abbau der Seite (etwa Sprung im Verlauf während des Drucks) dürfen nicht mehr navigieren.
  const aktiv = useRef(true);
  useLayoutEffect(() => {
    aktiv.current = true;
    return () => {
      aktiv.current = false;
    };
  }, []);
  const enthalten = arten.filter((art) => herkunft[art]);
  const beschaeftigt = entwurf.speichert || druck.laeuft;
  // RITA-1552 (E6): der „Gehört zu“-Vertrag der Rücksendung; nach CONTRACT_CHANGED neu bestimmt (solange gesperrt).
  const [vertragsbezug, setVertragsbezug] = useState(start.vertragsbezug);
  const [bezugLaedt, setBezugLaedt] = useState(false);
  const druckMeldung = druck.fehler || druckHinweis;
  // RITA-1601: Nur ein Druck mit Vertrag ersetzt einen gedruckten Vertrag und nennt den Vertragsinhaber (Vorgang Vertrag
  // mit enthaltenem Vertrag).
  const mitVertragsteil = start.vorgang === 'contract' && enthalten.includes('contract');
  // RITA-1601 (Fund 128): das beim Öffnen des Drucken-Fensters frisch geladene Aktionsprotokoll; null = noch nicht
  // geladen, 'fehler' = Laden gescheitert – in beiden Fällen wartet bzw. sperrt „Drucken“ im Fenster nur die Auswahl mit
  // Vertrag (Abschlussreview W1: nur das Anschreiben druckt wie bisher ohne Druckstand). Eine Antwort einer alten Anfrage
  // (Fenster inzwischen zu oder neu geöffnet) zählt nicht (`druckstandAnfrage`).
  const [druckstand, setDruckstand] = useState<Druckeintrag[] | null | 'fehler'>(null);
  const druckstandAnfrage = useRef(0);
  // RITA-1601 (Fund 63): Steht der abweichende Vertragsinhaber im sichtbaren Text des Vertrags? Sonst Kasten über dem Text.
  const vertragsinhaberName = vertragsinhaber.trim();
  const vertragsdokument = vertrag.zustand.dokument;
  const vertragsinhaberFehltImText = useMemo(
    () => mitVertragsteil && vertragsinhaberName !== '' && vertragsinhaberFehlt(vertragsdokument, vertragsinhaberName),
    [mitVertragsteil, vertragsinhaberName, vertragsdokument],
  );

  let status = NOCH_NICHT_GESPEICHERT;
  let statusfarbe = 'text.secondary';
  if (entwurf.geaendert) {
    status = NICHT_GESPEICHERTE_AENDERUNGEN;
    statusfarbe = 'error.main';
  } else if (entwurf.gespeichert) {
    status = gespeichertAmText(entwurf.gespeichert.am);
    statusfarbe = 'success.main';
  }

  /** Der sichtbare Stand der Editoren des Vorgangs mit der Herkunft aus dem Entwurf – wie beim Speichern. */
  const druckteile = (): Druckteil[] =>
    enthalten.map((art) => ({
      kind: art,
      dokument: speicherdokument((editoren[art] as VertragEditorApi).zustand),
      herkunft: herkunft[art] as Herkunft,
    }));

  /**
   * RITA-1552 (E6): nach CONTRACT_CHANGED den „Gehört zu“-Vertrag neu bestimmen. Scheitert das, bleibt der bisherige; der
   * Server lehnt dann erneut ab, und es wird wieder neu bestimmt.
   */
  const vertragsbezugNeuLaden = () => {
    setBezugLaedt(true);
    onProtokollLaden()
      .then((eintraege) => {
        if (!aktiv.current) return;
        unstable_batchedUpdates(() => {
          setVertragsbezug(letzterVertragsdruck(eintraege)?.id ?? null);
          setBezugLaedt(false);
        });
      })
      .catch(() => {
        if (aktiv.current) setBezugLaedt(false);
      });
  };

  const druckergebnis = (ergebnis: Druckergebnis) => {
    if (!aktiv.current) return;
    if (ergebnis.art === 'ok' && letzterDruck.current?.vollstaendig) {
      // F3: Der Entwurf ist erledigt – Freigabe und Navigation synchron hintereinander, ohne setState dazwischen
      // (jeder Render armiert den Verlassensschutz neu). Die offene Rückfrage verschwindet mit dem Abbau der Seite.
      freigabeRef.current();
      navigate(zumBerater);
      // Nur der Dateiabruf scheiterte: Die PDF liegt unter „Dokumente“; der Hinweis erscheint beim Berater.
      if (ergebnis.nichtGeoeffnet) enqueueSnackbar(ABGELEGT_NICHT_GEOEFFNET, { variant: 'warning' });
      return;
    }
    if (ergebnis.art === 'ok') {
      // Teil-Druck: Das nicht gedruckte Dokument bleibt im Entwurf, die Seite samt Änderungen bleibt offen. Scheiterte
      // nur der Dateiabruf, steht der Hinweis dazu schon in `druck.fehler` (keine Snackbar nötig).
      unstable_batchedUpdates(() => {
        setDruckfrage(null);
        setDruckErfolg(TEIL_GEDRUCKT_HINWEIS);
      });
      return;
    }
    unstable_batchedUpdates(() => {
      if (ergebnis.art === 'konflikt') setDruckfrage({ art: 'konflikt', konflikt: ergebnis.konflikt });
      else if (ergebnis.art === 'verworfen') setDruckfrage({ art: 'verworfen' });
      else setDruckfrage(null);
      // Herkunft `draft` prüft der Server nicht gegen die Vorlage; der Rückfall zeigt den Hinweis trotzdem.
      if (ergebnis.art === 'vorlageGeaendert') setDruckHinweis(vorlageGeaendertText(ergebnis.name, ergebnis.status));
    });
    // RITA-1552 (E6): Der Hinweis steht schon in `druck.fehler`; der nächste Druck soll zum jetzt neuesten Vertrag gehen.
    // Erkannt am Fehlercode des Servers, nicht am Nutzertext (der darf sich ändern).
    if (ergebnis.art === 'fehler' && ergebnis.code === 'CONTRACT_CHANGED') vertragsbezugNeuLaden();
  };

  const drucken = async (
    eingabe: ContractCreationPrintInput,
    vollstaendig: boolean,
    erwartet: string | null,
    bezug: number | null = vertragsbezug,
  ) => {
    letzterDruck.current = { eingabe, vollstaendig, vertragsbezug: bezug };
    // RITA-1552 (E6, Befund F1): bei der Rücksendung immer der „Gehört zu“-Vertrag oder ausdrücklich null (Fall B); beim
    // Vertrag null (der Server wertet ihn dort nicht aus).
    druckergebnis(await druck.drucken(eingabe, erwartet, start.vorgang === 'return' ? bezug : null));
  };

  /**
   * „Drucken“ in der Titelzeile: das Häkchen-Fenster öffnen. RITA-1601 (Fund 128): mit enthaltenem Vertrag zugleich das
   * Aktionsprotokoll frisch laden – die Rückfrage „Schon ein Vertrag gedruckt“ braucht den Stand von jetzt, und nach dem
   * Klick im Fenster darf nichts mehr warten (der Druck-Hook öffnet den Tab im Klick).
   */
  const druckenOeffnen = () => {
    // Ein alter Hinweis gehört zum vorigen Versuch; das Fenster beginnt ohne ihn.
    druck.fehlerSchliessen();
    setDruckHinweis('');
    setDruckErfolg('');
    setDruckfrage({ art: 'auswahl' });
    if (!mitVertragsteil) return;
    setDruckstand(null);
    druckstandAnfrage.current += 1;
    const anfrage = druckstandAnfrage.current;
    const aktuell = () => aktiv.current && anfrage === druckstandAnfrage.current;
    onProtokollLaden()
      .then((eintraege) => {
        if (aktuell()) setDruckstand(eintraege);
      })
      .catch(() => {
        // Ohne Druckstand kein Druck mit Vertrag – sonst könnte die Rückfrage fehlen. Das Fenster bleibt offen mit Hinweis;
        // nur das Anschreiben lässt sich weiter drucken, sonst „Abbrechen“ und erneut „Drucken“ (lädt neu).
        if (aktuell()) setDruckstand('fehler');
      });
  };

  /** Das Häkchen-Fenster schließen; eine noch laufende Anfrage des Druckstands zählt dann nicht mehr. */
  const druckenAbbrechen = () => {
    druckstandAnfrage.current += 1;
    setDruckfrage(null);
  };

  /**
   * Häkchen bestätigt (F4): Vorprüfung vor dem Tab; die Revision nur bei vollständiger Auswahl (F11). RITA-1552: ohne
   * Häkchen (Rücksendung) sind alle Dokumente gewählt. Danach die Gründe für eine Rückfrage (RITA-1552, RITA-1601).
   */
  const druckBestaetigt = (auswahl: Druckauswahl) => {
    const teile = druckteile();
    const eingabe = druckeingabeAusEditoren(teile, auswahl, arten);
    const pruefFehler = vorpruefung(eingabe);
    if (pruefFehler) {
      setDruckfrage(null);
      setDruckHinweis(pruefFehler);
      return;
    }
    const vollstaendig = alleEnthaltenAngehakt(enthalten, auswahl);
    const erwartet = vollstaendig ? entwurf.revision : null;
    // RITA-1552 (Bild F b): Beim Anlegen leere Angaben → erst fragen; das Drucken-Fenster weicht der Rückfrage.
    // RITA-1600 (Fund 107): nur Angaben der angehakten Dokumente.
    const gruende: Druckgruende = {
      zeilen: fehlendeAngabenAusGemerkten(
        start.advisorValues,
        beraterschluesselDerAuswahl(
          start.teile,
          enthalten.filter((art) => auswahl[art]),
        ),
      ),
    };
    // RITA-1601: nur bei einem Druck MIT Vertrag – nur er ersetzt den gedruckten Vertrag und nennt den Vertragsinhaber.
    if (mitVertragsteil && auswahl.contract) {
      // Der Knopf des Fensters wartet auf den Druckstand; ohne ihn (Sicherheitsnetz) kein Druck mit Vertrag.
      if (!Array.isArray(druckstand)) return;
      gruende.schonGedruckt = schonGedrucktGrund(
        druckstand,
        bestaetigterVertragsdruck,
        entwurf.gespeichert?.am ?? null,
      );
      const vertragsteil = teile.find((eintrag) => eintrag.kind === 'contract');
      if (vertragsteil && vertragsinhaberFehlt(vertragsteil.dokument, vertragsinhaberName)) {
        gruende.vertragsinhaber = vertragsinhaberName;
      }
    }
    if (hatGruende(gruende)) {
      setDruckfrage({ art: 'rueckfrage', eingabe, vollstaendig, erwartet, gruende });
      return;
    }
    drucken(eingabe, vollstaendig, erwartet).catch(() => undefined);
  };

  /** RITA-1552: „Trotzdem drucken“ der Rückfrage – dieselbe Eingabe, synchron im Klick (kein `await` davor). */
  const rueckfrageTrotzdemDrucken = () => {
    if (!druckfrage || druckfrage.art !== 'rueckfrage') return;
    // RITA-1601 (Fund 128): Das Ersetzen genau dieses Vertrags ist bestätigt – kein zweites Fragen, etwa nach einem Fehler.
    if (druckfrage.gruende.schonGedruckt) onVertragsdruckBestaetigt?.(druckfrage.gruende.schonGedruckt.eintragId);
    drucken(druckfrage.eingabe, druckfrage.vollstaendig, druckfrage.erwartet).catch(() => undefined);
  };

  /** F14: nach CONFLICT mit der Revision aus der Warnung, nach DISCARDED ohne Revision – dieselbe Eingabe. */
  const trotzdemDrucken = () => {
    const letzter = letzterDruck.current;
    // Nur aus der Warnung F14; keine zweite Rückfrage „Beim Anlegen fehlten Angaben“ für dieselbe Eingabe (RITA-1552).
    if (!letzter || !druckfrage || (druckfrage.art !== 'konflikt' && druckfrage.art !== 'verworfen')) return;
    drucken(
      letzter.eingabe,
      letzter.vollstaendig,
      druckfrage.art === 'konflikt' ? druckfrage.konflikt.revision : null,
      letzter.vertragsbezug,
    ).catch(() => undefined);
  };

  const verlassenSpeichern = async () => {
    const weiter = verlassen;
    if (await entwurf.speichern()) {
      setVerlassen(null);
      weiter?.();
    } else {
      setVerlassen(null);
    }
  };

  const neuBeginnen = async () => {
    setNeuLaedt(true);
    const meldung = await onNeuBeginnen(entwurf.revision);
    // Ohne Meldung ersetzt die Seite diese Sitzung durch den neuen Anfang.
    if (meldung !== null) {
      setKeineVorlage(meldung);
      setNeuLaedt(false);
    }
  };

  // RITA-1585: Der Knopf „Handbuch“ steht rechts neben der Pfadzeile, nicht darin (die Pfadzeile bleibt wie bisher).
  const pfadzeile = (
    <Box
      component="nav"
      aria-label="Pfadzeile"
      sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', mb: 1, gap: 0.5 }}
    >
      <Button
        size="small"
        disabled={druck.laeuft}
        onClick={() => navigate(PagePathname.alleBerater)}
        sx={{ color: 'text.secondary', minWidth: 0, textTransform: 'none' }}
      >
        {PFAD_BERATER}
      </Button>
      <Typography color="text.secondary">›</Typography>
      <Button
        size="small"
        disabled={druck.laeuft}
        onClick={() => navigate(zumBerater)}
        sx={{ color: 'text.secondary', minWidth: 0, textTransform: 'none' }}
      >
        {beraterName}
      </Button>
      <Typography color="text.secondary">›</Typography>
      <Typography variant="body2" color="text.secondary">
        {konfig.pfad}
      </Typography>
      <Typography color="text.secondary">›</Typography>
      <Typography variant="body2" aria-current="page">
        {PFAD_BEARBEITEN}
      </Typography>
    </Box>
  );

  return (
    <HandbuchArbeitsflaeche
      seite="vertragBearbeiten"
      pfadzeile={pfadzeile}
      obenAbstandPx={leisten?.appAbstand ?? APP_KOPF_ABSTAND_PX}
      mindestInhaltBreitePx={INHALT_MINDESTBREITE_PX}
      leistenBedarfPx={null}
      rahmenTestId="entwurf-seite"
    >
      <Verlassensschutz
        key={location.key}
        geaendert={entwurf.geaendert}
        freigabeRef={freigabeRef}
        onBlockiert={(weiter) => setVerlassen(() => weiter)}
      />
      <VertragTitelzeile
        titel={konfig.seitenTitel(beraterName)}
        status={
          <Typography role="status" data-testid="entwurf-speicherstand" variant="caption" sx={{ color: statusfarbe }}>
            {status}
          </Typography>
        }
        fehler={
          <>
            {entwurf.fehler ? (
              <Alert
                severity="error"
                sx={{ mt: 1 }}
                data-testid="entwurf-speicherfehler"
                onClose={entwurf.fehlerSchliessen}
              >
                {entwurf.fehler}
              </Alert>
            ) : null}
            {druckMeldung ? (
              // Abgelegt, aber nicht geöffnet: Warnung wie in der Karte (VertragserstellungKarte), kein Fehler.
              <Alert
                severity={druckMeldung === ABGELEGT_NICHT_GEOEFFNET ? 'warning' : 'error'}
                sx={{ mt: 1 }}
                data-testid="entwurf-druckfehler"
                onClose={() => {
                  druck.fehlerSchliessen();
                  setDruckHinweis('');
                }}
              >
                {druckMeldung}
              </Alert>
            ) : null}
            {druckErfolg ? (
              <Alert
                severity="success"
                sx={{ mt: 1 }}
                data-testid="entwurf-gedruckt-hinweis"
                onClose={() => setDruckErfolg('')}
              >
                {druckErfolg}
              </Alert>
            ) : null}
          </>
        }
        aktionen={
          <>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              disabled={beschaeftigt}
              onClick={() => navigate(zumBerater)}
              sx={{ textTransform: 'none' }}
            >
              {ZURUECK_ZUM_BERATER}
            </Button>
            <Button
              variant="outlined"
              startIcon={<SaveIcon />}
              disabled={beschaeftigt}
              onClick={() => {
                entwurf.speichern().catch(() => undefined);
              }}
              data-testid="entwurf-speichern-knopf"
              sx={{ textTransform: 'none' }}
            >
              {entwurf.speichert ? WIRD_GESPEICHERT : ENTWURF_SPEICHERN}
            </Button>
            <Button
              variant="contained"
              color="success"
              startIcon={<PrintOutlinedIcon />}
              disabled={beschaeftigt || bezugLaedt}
              onClick={druckenOeffnen}
              data-testid="entwurf-drucken-knopf"
              sx={{ textTransform: 'none' }}
            >
              {druck.laeuft ? WIRD_GEDRUCKT : DRUCKEN}
            </Button>
          </>
        }
      />
      <Tabs
        value={reiter}
        onChange={(_event, wert: ContractCreationKind) => setReiter(wert)}
        aria-label="Dokumente des Entwurfs"
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        {arten.map((art) => {
          const eintrag = teil(art);
          return (
            <Tab
              key={art}
              value={art}
              disabled={!eintrag || druck.laeuft}
              label={eintrag ? eintrag.herkunft.template_name : KEINE_VORLAGE_REITER[art]}
              id={`entwurf-reiter-${art}`}
              aria-controls="entwurf-reiterinhalt"
              data-testid={`entwurf-reiter-${art}`}
              sx={{ textTransform: 'none', fontWeight: 600 }}
            />
          );
        })}
      </Tabs>
      {/* RITA-1601 (Fund 63): Kasten oben über dem Text, auf beiden Reitern – er betrifft den Vertrag dieser Seite. */}
      {vertragsinhaberFehltImText && (
        <Alert severity="warning" sx={{ mb: 2 }} data-testid="entwurf-vertragsinhaber-hinweis">
          {vertragsinhaberFehltSeiteText(vertragsinhaberName)}
        </Alert>
      )}
      <Box role="tabpanel" id="entwurf-reiterinhalt" aria-labelledby={`entwurf-reiter-${reiter}`}>
        <VertragArbeitsbereich
          key={reiter}
          editor={editoren[reiter] as VertragEditorApi}
          vertragsarten={vertragsarten.stand}
          gesperrt={beschaeftigt}
          onVertragsartenErneutLaden={vertragsarten.erneutLaden}
          festeWerte={datum}
        />
      </Box>
      {druckfrage?.art === 'auswahl' && (
        <DruckenDialog
          teile={enthalten.map((art) => ({
            kind: art,
            name: (herkunft[art] as Herkunft).template_name.trim() || ART_KURZ[art],
          }))}
          beraterName={beraterName}
          drucktag={heute}
          ohneAuswahl={!konfig.haekchen}
          laeuft={druck.laeuft}
          // RITA-1601: Nur die Auswahl mit Vertrag wartet auf den frisch geladenen Druckstand; nur das Anschreiben nicht.
          druckenGesperrt={(auswahl) => mitVertragsteil && !!auswahl.contract && !Array.isArray(druckstand)}
          warnung={druckstand === 'fehler' ? PROTOKOLL_LADEFEHLER : null}
          onAbbrechen={druckenAbbrechen}
          onDrucken={druckBestaetigt}
        />
      )}
      {druckfrage?.art === 'rueckfrage' && (
        <DruckRueckfrageDialog
          variante="seite"
          gruende={druckfrage.gruende}
          laeuft={druck.laeuft}
          onAbbrechen={() => setDruckfrage(null)}
          onTrotzdem={rueckfrageTrotzdemDrucken}
        />
      )}
      {druckfrage && (druckfrage.art === 'konflikt' || druckfrage.art === 'verworfen') && (
        <DruckKonfliktDialog
          art={druckfrage.art}
          konflikt={druckfrage.art === 'konflikt' ? druckfrage.konflikt : undefined}
          laeuft={druck.laeuft}
          onStandLaden={() => {
            freigabeRef.current();
            onStandLaden();
          }}
          onZurueckZumBerater={() => {
            // Wie nach dem Druck: Freigabe und Navigation synchron, ohne setState dazwischen.
            freigabeRef.current();
            navigate(zumBerater);
          }}
          onTrotzdemDrucken={trotzdemDrucken}
        />
      )}
      {verlassen !== null && (
        <SeiteVerlassenDialog
          speichert={entwurf.speichert}
          onWeiterBearbeiten={() => setVerlassen(null)}
          onVerwerfen={() => {
            const weiter = verlassen;
            setVerlassen(null);
            weiter?.();
          }}
          onSpeichern={() => {
            verlassenSpeichern().catch(() => undefined);
          }}
        />
      )}
      {entwurf.konflikt && (
        <EntwurfKonfliktDialog
          konflikt={entwurf.konflikt}
          speichert={entwurf.speichert}
          trotzdemMoeglich={entwurf.trotzdemMoeglich}
          onStandLaden={() => {
            freigabeRef.current();
            onStandLaden();
          }}
          onZurueckZumBerater={() => {
            freigabeRef.current();
            navigate(zumBerater);
          }}
          onTrotzdemSpeichern={() => {
            entwurf.trotzdemSpeichern().catch(() => undefined);
          }}
        />
      )}
      {hinweis && (
        <EntwurfGeaendertDialog
          hinweis={hinweis}
          keineVorlage={keineVorlage}
          laedt={neuLaedt}
          onBehalten={() => {
            setHinweis(null);
            setKeineVorlage(null);
          }}
          onNeuBeginnen={() => {
            neuBeginnen().catch(() => undefined);
          }}
        />
      )}
    </HandbuchArbeitsflaeche>
  );
}

export default function EntwurfBearbeitung({
  agentId,
  beraterName,
  start,
  heute,
  onStandLaden,
  onNeuBeginnen,
  onGespeichert,
  onProtokollLaden,
  vertragsinhaber,
  bestaetigterVertragsdruck,
  onVertragsdruckBestaetigt,
}: Props) {
  return (
    <VertragLeistenRahmen>
      <EntwurfInhalt
        agentId={agentId}
        beraterName={beraterName}
        start={start}
        heute={heute}
        onStandLaden={onStandLaden}
        onNeuBeginnen={onNeuBeginnen}
        onGespeichert={onGespeichert}
        onProtokollLaden={onProtokollLaden}
        vertragsinhaber={vertragsinhaber}
        bestaetigterVertragsdruck={bestaetigterVertragsdruck}
        onVertragsdruckBestaetigt={onVertragsdruckBestaetigt}
      />
    </VertragLeistenRahmen>
  );
}
